import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import UserManagementStore from '../../stores/UserManagementStore';
import UserManagementActionCreator from '../../actions/UserManagementActionCreator';
import NonBCustomerError from '../common/NonBCustomerError';
import ProductDetails from './ProductDetails';
import { CHOOSE_PRODUCT_CONTEXT } from '../../config/BioCatch';
import { BioCatchContext } from '../BioCatchContext';

class Product extends Component {
  constructor(props) {
    super(props);
    this.retryButton = this.retryButton.bind(this);
    this.state = {
      showPersonalProductPage: true,
    };
  }

  componentWillMount() {
    UserManagementStore.isSMEUser() &&
      this.setState({ showPersonalProductPage: false });
  }

  retryButton() {
    UserManagementActionCreator.getUserDetails();
  }

  render() {
    const { showPersonalProductPage } = this.state;
    const {
      products,
      triggerDashboardViewController_NoEligibleAccounts_ButtonTitle,
      productHeadErrorMessage,
      productBodyErrorMessage,
    } = this.props.content;
    return UserManagementStore.isCaDetailsUndefined() ? (
      <BioCatchContext context={CHOOSE_PRODUCT_CONTEXT}>
        <NonBCustomerError
          headerContent={products}
          buttonName2={
            triggerDashboardViewController_NoEligibleAccounts_ButtonTitle
          }
          bodyContent1={productHeadErrorMessage}
          bodyContent2={productBodyErrorMessage}
          handleButtonClick2={this.retryButton}
          headerFlag
          hideButton1
          componentName
          page
        />
      </BioCatchContext>
    ) : (
      <BioCatchContext context={CHOOSE_PRODUCT_CONTEXT}>
        <div>
          <ProductDetails
            isPersonalProduct={showPersonalProductPage}
            content={this.props.content}
          />
        </div>
      </BioCatchContext>
    );
  }
}

Product.propTypes = {
  content: PropTypes.object,
};

export default RequiresAuthenticatedUser(Product);
